<template>
	<div>
		<button
			v-if="result != null && typeof result === 'object'" 
			type="button" 
			class="btn btn-secondary px-0" 
			@click="previewResult(result)">[Object]</button>
		<button
			v-else-if="typeof result === 'string' && result.length > STRING_MAX_LENGTH"
			type="button"
			class="btn btn-secondary px-0"
			@click="previewResult(result)">{{trimString(result)}}</button>
		<span v-else-if="result != null">{{result}}</span>
	</div>
</template>

<script>
export default {
	name: 'TestResult',
	props: ['result'],
	components: {
	},
	created() {
		this.STRING_MAX_LENGTH = 50;
	},
	methods: {
		trimString(text) {
			if (text.length > this.STRING_MAX_LENGTH && text.split(' ').length > 1) {
				return this.truncText(text, 25);
			} else {
				return this.trueTrunc(text, 25);
			}
		},
		truncText: (text, length) => {
			if (!text) return '';
			let trim;
			if (text.length > length) {
				trim = text.substr(0, length);
				trim = trim.substr(0, Math.min(trim.length, trim.lastIndexOf(' ')));
				trim = trim + '...';
			} else {
				trim = text;
			}
			return trim;
		},
		trueTrunc: (text, length) => {
			if (!text) return '';
			let trim;
			if (text.length > length) {
				trim = text.substr(0, length);
				trim = trim + '...';
			} else {
				trim = text;
			}
			return trim;
		},
		previewResult(result) {
			this.$emit('previewResult', result);
		}
	}
};
</script>

<style>
</style>

